"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useStyles = void 0;
const makeStyles_1 = __importDefault(require("@material-ui/core/styles/makeStyles"));
exports.useStyles = makeStyles_1.default((theme) => {
    var _a, _b;
    return ({
        menu: {
            color: 'rgb(66, 66, 66)',
            backgroundColor: 'white',
            height: 68,
        },
        menuItem: {
            display: 'inline-block',
            padding: '4px 10px',
            overflow: 'visible',
        },
        menuItemText: {
            fontWeight: 400,
            fontSize: 14,
            letterSpacing: 0.2,
        },
        activeMenuItem: {
            position: 'relative',
            '&:after': {
                position: 'absolute',
                height: 2,
                right: 4,
                bottom: -1,
                left: 4,
                content: "''",
                backgroundColor: theme.palette.primary.main,
            },
        },
        subMenu: {
            position: 'absolute',
            backgroundColor: 'white',
            left: '100%',
            top: 0,
            zIndex: 5,
            boxShadow: (_a = theme === null || theme === void 0 ? void 0 : theme.eas) === null || _a === void 0 ? void 0 : _a.shadow[1],
            borderRadius: (_b = theme.eas) === null || _b === void 0 ? void 0 : _b.radius,
        },
        subMenuTopLevel: {
            left: 0,
            top: 29,
        },
        subMenuItem: {
            overflow: 'visible',
            minWidth: 200,
        },
        subMenuItemText: {
            fontWeight: 400,
            fontSize: 14,
            letterSpacing: 0.2,
        },
        subMenuAction: {
            fontSize: '0.875rem !important',
            color: '#7c7c7c',
        },
        subMenuArrow: {
            fontSize: '0.875rem !important',
        },
        shortcut: {},
    });
});
//# sourceMappingURL=menu-styles.js.map